import nBar from './nBar.vue'
import goBack from './goback'
import goSearch from './goSearch.vue'
import vTitle from './vTitle.vue'

export default {
    nBar,
    goBack,
    goSearch,
    vTitle
}